/**
 * WU-1.2 — shared priority-aging formula.
 *
 * Two twins run this computation (the api service `services/priority-aging.ts`
 * and the worker job `jobs/priority-aging.ts` — the worker cannot import from
 * apps/api, and it is the copy on the production schedule). The formula lives
 * here so the twins cannot drift: a worker tick recomputing effectivePriority
 * WITHOUT the breach boost would silently overwrite the boost right back off.
 */
/**
 * effectivePriority bump for SLA-breached documents so they sort first
 * everywhere queues order by `effectivePriority desc` (routes/queues peek,
 * queue-manager get-next, monitor).
 *
 * 1000 dominates any realistic aging contribution: base priorities are single
 * digits and aging accrues ~0.5 points/hour (a doc would need to wait ~83 days
 * at the default rate to accrue 1000 points), so a breached doc always
 * outranks un-breached work, while breached docs still order among themselves
 * by base priority + age.
 */
export const BREACH_BOOST = 1000;
/**
 * Priority points a pending document gains per hour waiting in its current
 * step when the job type doesn't override it. Mirrors the Prisma column
 * default (JobType.priorityAgingRate @default(0.5)).
 */
export const DEFAULT_PRIORITY_AGING_RATE = 0.5;
/**
 * Compute (never accumulate) a pending document's effective priority:
 *
 *   priority + hoursInStep * agingRate + (breached ? BREACH_BOOST : 0)
 *
 * Because the boost is part of the computed value, repeated aging passes over
 * an already-breached document are idempotent.
 */
export function computeEffectivePriority(priority, hoursInStep, agingRate, breached) {
    return priority + hoursInStep * agingRate + (breached ? BREACH_BOOST : 0);
}
//# sourceMappingURL=priority-aging.js.map